export default __webpack_public_path__ + "static/media/rancher.3534de63.svg";